Vue.component('ais-color-refinement-list', {
  template: "#ais-color-refinement-list",
  props: {
    items: { type: Array, required: true },
    refine: { type: Function, required: true },
    layout: { type: String, default: 'Grid' },
    shape: { type: String, default: 'Circle' },
    pinRefined: { type: Boolean, default: false },
    canToggleShowMore: { type: Boolean, default: false },
    isShowingMore: { type: Boolean, default: false },
    toggleShowMore: { type: Function, default: () => { } },
    colors: { type: Object, default: () => ({}) },
  },
  data: () => ({
    defaultColors: {
      beige: "#f5f5dc",      // beige
      schwarz: "#000000",    // black
      blau: "#0000ff",       // blue
      bronze: "#cd7f32",     // bronze
      braun: "#a52a2a",      // brown
      klar: "#d0d0d0",       // clear
      gold: "#ffd700",       // gold
      grau: "#808080",       // gray
      grün: "#008000",      // green
      orange: "#ffa500",     // orange
      rosa: "#ffc0cb",       // pink
      lila: "#800080",       // purple
      rot: "#ff0000",        // red
      silber: "#c0c0c0",     // silver
      türkis: "#40e0d0",    // turquoise
      weiss: "#ffffff",      // white
      gelb: "#ffff00"        // yellow
    },
  }),
  methods: {
    getColorStyle (colorName) {
      const colors = { ...this.defaultColors, ...this.colors };
      const color = colors[colorName];

      return color && {
        backgroundColor: color,
      };
    },
    getContrastColor (rgb) {
      const [r, g, b] = rgb;
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? 'black' : 'white';
    },
  },
});
